var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{staticClass:"justify-center",attrs:{"fluid":"","fill-height":""}},[_c('Spinner')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }